import { CLoadingButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react-pro';
import React from 'react';

const Modal = (props) => {
	return (
		<>
			<CModal size={props.size} scrollable={props.scrollable} backdrop='static' visible={props.visible} onClose={props.onClose} aria-labelledby='static_backdrop_modal'>
				<CModalHeader>
					<CModalTitle id='static_backdrop_modal'>{props.title}</CModalTitle>
				</CModalHeader>
				<CModalBody>{props.content}</CModalBody>
				{props.actions && (
					<CModalFooter>
						{props.actions?.map((action , i) => (
							<CLoadingButton key={i} color={action.color || 'primary'} style={action.style} onClick={action.onClick} disabled={action.disabled} loading={action.loading} id={action.id}>
								{action.text}
							</CLoadingButton>
						))}
					</CModalFooter>
				)}
			</CModal>
		</>
	);
};

export default Modal;
